import React, { useState } from 'react'
import SmartGrid from '@alejandro.devop/bootstrap-smart-grid'
import Panel from '@core/panel'
import { useTranslate } from '@core/hooks'
import { DictionaryKeyType } from '@core/translation-provider/translation.types'
import config from './grid.config'
import PerfectScrollbar from 'react-perfect-scrollbar'
import ClientDetail from '../client-detail/ClientDetail'

const RegisteredClients: React.FC = () => {
    const t = useTranslate('trikos')
    const [selectedClient, setSelectedClient] = useState<any>()

    const handleActionCall = (action: string, record: { id: any }) => {
        if (action === 'view') {
            setSelectedClient(record.id)
        }
    }
    return (
        <>
            <Panel title="registerd_clients">
                <PerfectScrollbar>
                    <SmartGrid
                        headerTextProcessor={(k: string) => t(k as DictionaryKeyType)}
                        textProcessor={(k: string, replacements) => {
                            const { key, value } = replacements || {}
                            const valuesToReplace = {}
                            if (key) {
                                valuesToReplace[key] = value
                            }
                            return t(k as DictionaryKeyType, {
                                ignoreScope: true,
                                replacements: valuesToReplace
                            })
                        }}
                        config={config}
                        onAcctionCalled={handleActionCall}
                    />
                </PerfectScrollbar>
            </Panel>
            {Boolean(selectedClient) && (
                <ClientDetail clientId={selectedClient} onClose={() => setSelectedClient(null)} />
            )}
        </>
    )
}

export default RegisteredClients
